<script setup lang="ts">
  import {
    PopoverContent,
    type PopoverContentEmits,
    type PopoverContentProps as RekaPopoverContentProps,
    PopoverPortal,
    useForwardPropsEmits
  } from 'reka-ui'
  import {
    computed,
    onMounted,
    onUnmounted,
    ref,
    type HTMLAttributes
  } from 'vue'
  import { cn } from '../../../lib/utils'
  import { useDialogZIndex } from '../../../composables/useDialogZIndex'
  import { injectPopoverRootContext } from 'reka-ui'

  export interface PopoverContentProps extends RekaPopoverContentProps {
    class?: HTMLAttributes['class']
  }

  defineOptions({
    inheritAttrs: false
  })

  const props = withDefaults(defineProps<PopoverContentProps>(), {
    align: 'center',
    sideOffset: 4
  })
  const emits = defineEmits<PopoverContentEmits>()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })

  const rootContext = injectPopoverRootContext()

  const { zIndex } = useDialogZIndex(rootContext.open)

  const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <PopoverPortal>
    <PopoverContent
      data-slot="popover-content"
      v-bind="{ ...forwarded, ...$attrs }"
      :class="
        cn(
          'bg-popover text-popover-foreground origin-(--reka-popover-content-transform-origin) outline-hidden w-72 rounded-md border p-4 shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          props.class
        )
      "
      :style="{ zIndex }"
    >
      <slot />
    </PopoverContent>
  </PopoverPortal>
</template>
